module.exports = __webpack_public_path__ + "img/logs.30c7a696.gif";